// removed by extract-text-webpack-plugin
module.exports = {"potw":"potw__1BqM5"};


//////////////////
// WEBPACK FOOTER
// ./components/potw/style.less
// module id = mNy6
// module chunks = 0